module.exports = __webpack_public_path__ + "static/media/medical.32cb1791.png";